import PropTypes from "prop-types";
import React, { Component } from "react";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import { checkIfEmpty } from "components/Shared/Formatters";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { NOT_PROVIDED } from "typeConstants/stringConstants";

class UserField extends Component {
  // PropDoc
  //
  //
  //  If the fieldValue is equal to the disabledFieldValue then the component will appear disabled
  //
  // dialogContents = [
  //   {fieldTitle, fieldValue}
  // ]

  //ctr
  constructor(props) {
    super(props);
    this.renderDialogContents = this.renderDialogContents.bind(this);
    this.checkIfDisabled = this.checkIfDisabled.bind(this);
    this.tooltip = this.tooltip.bind(this);
    this.checkIfEmail = this.checkIfEmail.bind(this);
    this.state = {
      disabled: false
    };
  }

  //lifecycle
  UNSAFE_componentWillReceiveProps() {
    this.checkIfDisabled();
  }

  checkIfDisabled() {
    if (
      (this.props.disabledFieldValue === this.props.fieldValue ||
        !this.props.fieldValue) &&
      this.state.disabled === false
    ) {
      this.setState({ disabled: true });
    } else {
      this.setState({
        disabled: false
      });
    }
  }

  checkIfEmail(fieldTitle, fieldValue) {
    if (fieldTitle.toUpperCase().includes("EMAIL")) {
      return (
        <a
          className="caseheader-contactinfo-tooltip-hyperlink"
          href={"mailto:" + fieldValue}
        >
          {checkIfEmpty(fieldValue)}
        </a>
      );
    }
    return checkIfEmpty(fieldValue);
  }

  renderDialogContents() {
    if (this.props.dialogContents) {

      return(
        <div className="tipped-cell-tip">
          <Card className="card-unnested">
              <CardHeader title={this.props.tooltipTitle}/>
              <CardContent>
              <div className="md-grid">
                  <span className="tipped-cell-label md-cell--6">
                  {
                  this.props.dialogContents.map(field => {
                    if(field.fieldValue === NOT_PROVIDED) {
                      return;
                    }
                    return (
                      <div className="field-label" key={`${field.fieldTitle} ${field.fieldValue} label`}> 
                        {field.fieldTitle}
                      </div>
                    );
                  })
                  }
                  </span>
                  <span className="tipped-cell-value md-cell--6">
                  {
                  this.props.dialogContents.map(field => {
                    if(field.fieldValue === NOT_PROVIDED) {
                      return;
                    }
                    return(
                      <div className="field-value" key={`${field.fieldTitle} ${field.fieldValue} value`}> 
                      {this.checkIfEmail(field.fieldTitle, field.fieldValue)}
                    </div>
                    );
                  })
                  }
                  </span>
                </div>
              </CardContent>
          </Card>
        </div>
    );
    }
    return;
  }

  tooltip() {
    if (this.props.dialogContents) {
      return (
        <div data-tooltip-id={this.props.fieldTitle + "-tooltip"}>
          <ReactTooltip
            id={this.props.fieldTitle + "-tooltip"}
            place="right"
            delayHide={100}
            className="m-tooltip"
          >
            {this.renderDialogContents()}
          </ReactTooltip>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="md-cell--6 md-text-field-container md-full-width md-text-field-container--disabled md-text-field-container--input user-field">
        <div className="md-floating-label--disabled">
          {this.props.fieldTitle}
        </div>

        <span data-tooltip-id={this.props.fieldTitle + "-tooltip"}>
          <Button
            disabled={this.state.disabled}
            className="appraiser-caseheader-button"
            variant="text"
          >
            {checkIfEmpty(this.props.fieldValue)}
          </Button>
        </span>
        {this.state.disabled === false && this.tooltip()}
      </div>
    );
  }
}

UserField.propTypes = {
  fieldTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  tooltipTitle: PropTypes.string,
  fieldValue: PropTypes.string,
  dialogContents: PropTypes.array,
  disabledFieldValue: PropTypes.string
};

export default UserField;
